import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';

const selectors = {
  modal: 'dialog',
  modalClose: '[data-dialog-close]',
  modalContent: '[data-dialog-content]',
};

/**
 * Wrapper class for modal dialogs.
 * A modal can be created in markup using a link to a hidden element
 *
 * @export
 * @class Modal
 */
export default class Modal {
  constructor() {
    this.modalEl = document.getElementById(selectors.modal);
    this.modalClose = this.modalEl.querySelector(selectors.modalClose);
    this.modalContent = this.modalEl.querySelector(selectors.modalContent);

    this.modalClose.addEventListener('click', () => {
      this.close();
    });
  }

  update(content) {
    this.modalContent.innerHTML = content;
  }

  /**
   * Open a modal with contents from selector
   *
   * @param selector The contents to inject
   */
  open(content) {
    if (!this.modalEl) {
      return;
    }

    this.modalEl.showModal();
    disablePageScroll();

    this.update(content);
  }

  /**
   * Close a modal
   */
  close() {
    this.modalEl.close();
    enablePageScroll();
  }
}
